import { render, staticRenderFns } from "./ClienteExport.vue?vue&type=template&id=6e1695b8"
import script from "./ClienteExport.vue?vue&type=script&lang=js"
export * from "./ClienteExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports